var map = {
	"./bow.svg": "tdB+",
	"./collab.svg": "9/Gm",
	"./demo.gif": "CMKK",
	"./feature-access.svg": "2GoS",
	"./feature-editor.svg": "Igbi",
	"./feature-workflow.svg": "yZQz",
	"./github.svg": "3qvr",
	"./heart.svg": "Ymo7",
	"./helix.svg": "pqNs",
	"./netlify-cms-logo.svg": "FCIV",
	"./netlify-logo.svg": "rG4x",
	"./play.svg": "5sCQ",
	"./screenshot-content.png": "sj7R",
	"./screenshot-editor.jpg": "X3Zr",
	"./screenshot-editor.png": "GP9F",
	"./screenshot-editorial.png": "mEvR",
	"./screenshot-identity.png": "wMx1",
	"./search.svg": "v7h9",
	"./smashing-logo.svg": "iuY/",
	"./wavy-divider.svg": "x24I"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "lc2H";